export const PRODUCTS_LIST_INITING             = 'PRODUCTS_LIST_INITING'
export const PRODUCTS_LIST_REQUESTING          = 'PRODUCTS_LIST_REQUESTING'
export const PRODUCTS_LIST_SUCCESS             = 'PRODUCTS_LIST_SUCCESS'
export const PRODUCTS_LIST_ERROR               = 'PRODUCTS_LIST_ERROR'   

export const PRODUCTS_EXPORT_XLS_INITING       = 'PRODUCTS_EXPORT_XLS_INITING'
export const PRODUCTS_EXPORT_XLS_REQUESTING    = 'PRODUCTS_EXPORT_XLS_REQUESTING'
export const PRODUCTS_EXPORT_XLS_SUCCESS       = 'PRODUCTS_EXPORT_XLS_SUCCESS'
export const PRODUCTS_EXPORT_XLS_ERROR         = 'PRODUCTS_EXPORT_XLS_ERROR'

export const PRODUCTS_DETAIL_INITING           = 'PRODUCTS_DETAIL_INITING'
export const PRODUCTS_DETAIL_REQUESTING        = 'PRODUCTS_DETAIL_REQUESTING'
export const PRODUCTS_DETAIL_SUCCESS           = 'PRODUCTS_DETAIL_SUCCESS'
export const PRODUCTS_DETAIL_ERROR             = 'PRODUCTS_DETAIL_ERROR'   

export const PRODUCTS_UPDATE_REQUESTING        = 'PRODUCTS_UPDATE_REQUESTING'
export const PRODUCTS_UPDATE_SUCCESS           = 'PRODUCTS_UPDATE_SUCCESS'
export const PRODUCTS_UPDATE_ERROR             = 'PRODUCTS_UPDATE_ERROR'   

export const PRODUCTS_REMOVE_REQUESTING        = 'PRODUCTS_REMOVE_REQUESTING'
export const PRODUCTS_REMOVE_SUCCESS           = 'PRODUCTS_REMOVE_SUCCESS'
export const PRODUCTS_REMOVE_ERROR             = 'PRODUCTS_REMOVE_ERROR' 

export const PRODUCTS_DETAIL_API               = '/api/v1/management/products_detail_by_id'  
export const PRODUCTS_LIST_API                 = '/api/v1/management/products_list_by_store'   
export const PRODUCTS_UPDATE_API               = '/api/v1/management/products_update_by_id' 
export const PRODUCTS_DVT_LIST_API             = '/api/v1/management/dvt_list_by_store' 
export const PRODUCTS_NGANHHANG_LIST_API       = '/api/v1/management/nganhang_list_by_store'
export const PRODUCTS_REMOVE_API               = '/api/v1/management/products_remove_by_id' 
export const PRODUCTS_EXPORT_XLS_API           = '/api/v1/management/products_export_by_store' 


// WEBPACK FOOTER //
// ./src/views/Products/constants.js